import { DocumentTextIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { StringTranslations } from '@services';

type Props ={
  handleShowTranscript: Function,
  lang: string,
  styles: string,
  stringTranslations: StringTranslations,
}

export default function ViewTranscript(
  {
    handleShowTranscript, lang, styles, stringTranslations,
  } : Props,
) {
  return (
    <button
      type="button"
      onClick={() => handleShowTranscript()}
      className={`${styles} flex cursor-pointer items-center font-semibold whitespace-nowrap uppercase`}
    >
      <DocumentTextIcon className="mr-1 h-[14px]" />
      <p className="text-chdGreen-light tracking-wider hover:text-chdGreen-hover">
        {stringTranslations['view-transcript'][lang]}
      </p>
    </button>
  );
}
